import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import backgroundImg from '../../../assets/background-2.svg';
import logoIcon from '../../../assets/logo-icon-dark-blue.svg';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    padding: '0',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center top',
    backgroundSize: 'cover',
    backgroundImage: `url(${backgroundImg})`
  },
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    padding: '4rem 1.5rem',
    height: '100%',
    minHeight: '100%',
  },
  main: {
    paddingLeft: '4.4rem',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
  text: {
    width: '60%',
    margin: '2rem 0',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  img: {
    width: '4.4rem',
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const ComingSoon = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Container maxWidth="lg" fixed disableGutters={true}>
        <Grid container className={classes.content}>
          <Grid item md={12}>
            <img src={logoIcon} className={classes.img} alt="icon"/>
          </Grid>
          <Grid item md={12} className={classes.main}>
            <Typography variant="h1" color="primary" className={classes.text}>
              Stay tuned for this feature!
            </Typography>
            <Typography variant="body2" className={classes.text}>
              We&apos;re working on this so please check back soon. If this is important to you, please let us know via the <Link to="/profile/feedback" className={classes.link}>feedback</Link> section.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default ComingSoon;
